import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SmoothScroll } from "@/components/common/SmoothScroll";
import { Loader } from "@/components/common/Loader";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Residences from "@/pages/Residences";
import ResidenceDetail from "@/pages/ResidenceDetail";
import Rentals from "@/pages/Rentals";
import RentalCity from "@/pages/RentalCity";
import RentalType from "@/pages/RentalType";
import RentalDetail from "@/pages/RentalDetail";
import Relocating from "@/pages/Relocating";
import CommunityDetail from "@/pages/CommunityDetail";
import Owners from "@/pages/Owners";
import Neighbourhoods from "@/pages/Neighbourhoods";
import NeighbourhoodDetail from "@/pages/NeighbourhoodDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AdminImport from "@/pages/AdminImport";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <Loader />
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/residences" element={<Residences />} />
              <Route path="/residences/:slug" element={<ResidenceDetail />} />
              <Route path="/rentals" element={<Rentals />} />
              <Route path="/rentals/:city" element={<RentalCity />} />
              <Route path="/rentals/:city/:type" element={<RentalType />} />
              <Route
                path="/rentals/:city/:type/:slug"
                element={<RentalDetail />}
              />
              <Route path="/relocating" element={<Relocating />} />
              <Route path="/communities/:slug" element={<CommunityDetail />} />
              <Route path="/owners" element={<Owners />} />
              <Route path="/neighbourhoods" element={<Neighbourhoods />} />
              <Route path="/neighbourhoods/:slug" element={<NeighbourhoodDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/import" element={<AdminImport />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;

